import React from "react";
import { Select } from "../../form/select/index";
import { FormGroup } from "../../form/group/index";
import { Input } from "../../form/input/index";
import { Button } from "../../button/index";
import { FaBars, FaTrashAlt, FaCopy } from "react-icons/fa";
import InputMask from "react-input-mask";
import { InputBox } from "../../form/input.box/index";
import { Tooltip } from "../../tooltip/index";
import { Checkbox } from "../../form/checkbox";
import { arrayMove, SortableContainer, SortableElement, SortableHandle } from "react-sortable-hoc";
import styled from "styled-components";
import { AddTimeSlotIcon } from "../../icons/add-time-slot";
import { EllipsisIcon } from "../../bumpViews/ellipsis";
import { BottomMenuControls } from "./bottom_menu_edit";
import { ButtonList } from "../menu.ingredients/button-list";
const Wrapper = styled("div") `
    .menu-item-active {
        background: #FFF3F3;
        border: 1px solid #FB2F2F;
    }
`;
const AddTimeSlotButtonStyle = styled.div `
	display: flex;
	width: 100%;
	padding: 12px;
	justify-content: center;
	align-items: center;
	border-radius: 4px;
	border: 1px solid #DFDFDF;
	background:  #F1F4F7;
	font-size: 14px;
	font-style: normal;
	font-weight: 600;
	gap: 4px;
`;
const Days = [
    { label: "Monday", value: "Monday" },
    { label: "Tuesday", value: "Tuesday" },
    { label: "Wednesday", value: "Wednesday" },
    { label: "Thursday", value: "Thursday" },
    { label: "Friday", value: "Friday" },
    { label: "Saturday", value: "Saturday" },
    { label: "Sunday", value: "Sunday" },
];
const DragHandle = SortableHandle(() => {
    return (React.createElement(InputBox, { className: "no-round width40 cursor-move flex-center" },
        React.createElement("p", { className: "big font-bold" },
            React.createElement(FaBars, null))));
});
const SortableItem = SortableElement((props) => {
    const { openActionItem, itemIndex, itemsLength, change, copy, remove, allowNone, isMobile, setOpenActionItem, setActiveIndex, activeIndex } = props;
    const h = props.item;
    const handleOpenAction = (index) => {
        setActiveIndex(index);
        setOpenActionItem(!openActionItem);
    };
    return (React.createElement(Wrapper, { key: itemIndex, className: "flex-line", style: { alignItems: "flex-end" } },
        !props.isMobile && React.createElement(DragHandle, null),
        React.createElement("div", { className: activeIndex === itemIndex && openActionItem ? "menu-item-active flex-line" : "flex-line", style: { alignItems: "flex-end" } },
            React.createElement(FormGroup, { className: "m-b-0", no_border: true },
                React.createElement(Select, { className: "no-round", options: Days, style: { width: isMobile ? "107px" : "120px" }, value: h.day, onChange: (e) => change(itemIndex, "day", e.target.value), required: true })),
            React.createElement(FormGroup, { className: "m-b-0", no_border: true },
                React.createElement(InputMask, { mask: "99:99", value: h.open, onChange: (e) => change(itemIndex, "open", e.target.value), disabled: h.h24 }, (inputProps) => React.createElement(Input, { type: "text", className: "no-round", style: { width: !isMobile ? "100px" : "75px" }, placeholder: "00:00", ...inputProps, disabled: h.h24 }))),
            React.createElement(FormGroup, { className: "m-b-0", no_border: true },
                React.createElement(InputMask, { mask: "99:99", value: h.close, onChange: (e) => change(itemIndex, "close", e.target.value), disabled: h.h24 }, (inputProps) => React.createElement(Input, { type: "text", className: "no-round", style: { width: !isMobile ? "100px" : "75px" }, placeholder: "00:00", ...inputProps, disabled: h.h24 }))),
            React.createElement(FormGroup, { className: "m-b-0", no_border: true },
                React.createElement(InputBox, { className: "no-round flex-center width75" },
                    React.createElement(Checkbox, { id: `${itemIndex}-24-hours-checkbox`, checked: h.h24, onChange: (e) => change(itemIndex, "h24", e.target.checked) }))),
            isMobile && React.createElement(FormGroup, { className: "m-b-0", no_border: true },
                React.createElement(InputBox, { className: "no-round flex-center", style: { width: '66px' } },
                    React.createElement("div", { onClick: () => handleOpenAction(itemIndex) },
                        React.createElement(EllipsisIcon, null))))),
        (allowNone || itemsLength !== 1) && !props.isMobile &&
            React.createElement(Tooltip, { text: "Delete", width: 65, position: "top", disable: itemIndex !== 0 },
                React.createElement(Button, { type: "button", className: "no-round", paddinglr: 5, color: "white", onClick: () => remove(itemIndex) },
                    React.createElement(FaTrashAlt, null))),
        !props.isMobile && React.createElement(Tooltip, { text: "Copy", width: 65, position: "top", disable: itemIndex !== 0 },
            React.createElement(Button, { type: "button", className: "no-round", paddinglr: 5, color: "white", onClick: () => copy(itemIndex) },
                React.createElement(FaCopy, null)))));
});
const SortableItemContainer = SortableContainer((props) => {
    return (React.createElement("div", null, props.items.map((item, i) => (React.createElement(SortableItem, { key: `item-${i}`, index: i, item: item, itemIndex: i, itemsLength: props.items.length, change: props.change, remove: props.remove, copy: props.copy, allowNone: props.allowNone, isMobile: props.isMobile, up: props.up, down: props.down, setActiveIndex: props.setActiveIndex, setOpenActionItem: props.setOpenActionItem, openActionItem: props.openActionItem, activeIndex: props.activeIndex })))));
});
export class FieldOpeningHours extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeIndex: -1,
            openActionItem: false,
        };
    }
    add = () => {
        const hours = [...this.props.hours];
        hours.push({
            day: "Monday",
            open: "09:00",
            close: "21:00",
            h24: false,
        });
        this.props.onChange(hours);
    };
    copy = (i) => {
        const hours = [...this.props.hours];
        const hour = { ...hours[i] };
        hours.push(hour);
        this.props.onChange(hours);
    };
    remove = (i) => {
        const hours = ([...this.props.hours]);
        hours.splice(i, 1);
        this.props.onChange(hours);
    };
    change = (i, key, value) => {
        const hours = [...this.props.hours];
        hours[i][key] = value;
        this.props.onChange(hours);
    };
    onSortEnd = ({ oldIndex, newIndex }) => {
        const { onChange, hours } = this.props;
        onChange(arrayMove(hours, oldIndex, newIndex));
    };
    onUp = (index) => {
        const { onChange, hours } = this.props;
        if (index > 0) {
            const updatedHours = arrayMove(hours, index, index - 1);
            onChange(updatedHours);
            this.setState({ activeIndex: index - 1 });
        }
    };
    onDown = (index) => {
        const { onChange, hours } = this.props;
        if (index < hours.length - 1) {
            const updatedHours = arrayMove(hours, index, index + 1);
            onChange(updatedHours);
            this.setState({ activeIndex: index + 1 });
        }
    };
    render() {
        const { hours, allowNone, isMobile } = this.props;
        if (hours.length === 0) {
            return (!isMobile ? (React.createElement(Button, { color: "primary-inverse", size: "xs", type: "button", onClick: this.add }, "Add Time Slot")) : React.createElement(AddTimeSlotButtonStyle, { onClick: this.add },
                " ",
                React.createElement(AddTimeSlotIcon, null),
                " Add Time Slot "));
        }
        return (React.createElement("div", null,
            !isMobile ? (React.createElement(Button, { color: "primary-inverse", size: "xs", type: "button", onClick: this.add }, "Add Time Slot")) : React.createElement(AddTimeSlotButtonStyle, { onClick: this.add },
                " ",
                React.createElement(AddTimeSlotIcon, null),
                " Add Time Slot "),
            React.createElement("div", { className: "flex-line", style: { alignItems: "flex-end" } },
                !isMobile ? (React.createElement("div", { style: { width: "40px", minWidth: "40px" } })) : (React.createElement("div", { style: { width: "40px", minWidth: "24px" } })),
                React.createElement("div", { className: "flex-line", style: { alignItems: "flex-end" } },
                    React.createElement(FormGroup, { style: { width: !isMobile ? "120px" : "90px" }, className: "m-b-0", title: "Day", small_title: true, no_border: true }),
                    React.createElement(FormGroup, { style: { width: !isMobile ? "100px" : "75px" }, className: "m-b-0", title: "Open", small_title: true, no_border: true }),
                    React.createElement(FormGroup, { style: { width: !isMobile ? "100px" : "80px" }, className: "m-b-0", title: "Close", small_title: true, no_border: true }),
                    React.createElement(FormGroup, { style: { width: "75px" }, className: "m-b-0", title: "24 Hour", small_title: true, no_border: true }),
                    isMobile && React.createElement(FormGroup, { style: { width: "75px" }, className: "m-b-0", title: "Action", small_title: true, no_border: true }))),
            React.createElement(SortableItemContainer, { helperClass: "zindex-100 bsl-2", pressDelay: 50, useDragHandle: true, items: hours, change: this.change, copy: this.copy, remove: this.remove, onSortEnd: this.onSortEnd, allowNone: allowNone || false, isMobile: isMobile, up: this.onUp, down: this.onDown, setOpenActionItem: (isActive) => this.setState({ openActionItem: isActive }), setActiveIndex: (index) => this.setState({ activeIndex: index }), openActionItem: this.state.openActionItem, activeIndex: this.state.activeIndex }),
            this.state.openActionItem && this.state.activeIndex >= 0 && (React.createElement(BottomMenuControls, { buttonList: ButtonList(() => this.onUp(this.state.activeIndex), () => this.onDown(this.state.activeIndex), () => this.remove(this.state.activeIndex), () => this.copy(this.state.activeIndex), () => this.setState({ openActionItem: false })) }))));
    }
}
//# sourceMappingURL=index.js.map